module.exports = __webpack_public_path__ + "static/irene_2-00dd9ae8730346a4417bc749a15bd74c.png";